import { render, staticRenderFns } from "./DetailPane.vue?vue&type=template&id=25cf0b45&scoped=true&"
import script from "./DetailPane.vue?vue&type=script&lang=ts&"
export * from "./DetailPane.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPane.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailPane.vue?vue&type=style&index=1&id=25cf0b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cf0b45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VProgressCircular})
